module.exports = __webpack_public_path__ + "static/media/bg_netizenpledge-CH_FINISH_Empty.349d65ef.png";